import { NgProviderHelper } from "@/helpers";

export const open = (name: string) => {
  const $rootScope = NgProviderHelper.getInstance("$rootScope");
  const modalService = NgProviderHelper.getInstance("modalService");

  modalService.open(name);
  $rootScope.$digest();
};

export const close = () => {
  const $rootScope = NgProviderHelper.getInstance("$rootScope");
  const modalService = NgProviderHelper.getInstance("modalService");

  modalService.close();
  $rootScope.$digest();
};
